module.exports = __webpack_public_path__ + "static/media/redFlag.fc4747ba.png";